import { Box, Typography, TextField, Stack } from '@mui/material'
import { UseFormRegister, FieldValues } from 'react-hook-form'
import { ICurrency } from '~/src/repositories/SettingCurrency/models/SettingCurrency'

export const Currency: React.FC<{
  index: number
  item: ICurrency
  label: string
  register: UseFormRegister<FieldValues>
}> = ({ index, item, label, register }): JSX.Element => (
  <Stack key={index} spacing={'16px'} direction={'row'} alignItems={'center'} mb={'16px'}>
    <Box
      sx={{
        width: '150px',
        marginLeft: '16px',
        height: '46px',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      {index === 0 && (
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: 14,
            color: '#000000',
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
    <Box sx={{ width: '100px' }}>{item.currency.name}</Box>
    <TextField
      defaultValue={item.rate}
      sx={{
        '& .MuiOutlinedInput-input': {
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: 14,
          color: '#222222',
          padding: '10px 12px',
        },
        width: '220px',
      }}
      size={'small'}
      {...register(item.currency.name)}
    />
  </Stack>
)
